import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../apiUrlConstant";
import { Redirect, withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import RentalDetails from "./tabSection/RentalDetails";
import PartiesUnitDetails from "./tabSection/PartiesUnitDetails";
import OccupierBrandDetails from "./tabSection/OccupierBrandDetails";
import BrokerDetails from "./tabSection/BrokerDetails";
import LeaseTermDetails from "./tabSection/LeaseTermDetails";
import LockInNoticePeriod from "./tabSection/LockInNoticePeriod";
import CamDetails from "./tabSection/CamDetails";
import Utilities from "./tabSection/Utilities";
import MarketingFund from "./tabSection/MarketingFund";
import PropertyTax from "./tabSection/PropertyTax";
import ParkingStorageSignage from "./tabSection/ParkingStorageSignage";
import RentDeposit from "./tabSection/RentDeposit";
import CamDeposit from "./tabSection/CamDeposit";
import OtherDeposit from "./tabSection/OtherDeposit";
import UploadDocuments from "./tabSection/UploadDocuments";
import CommercialClauses from "./tabSection/CommercialClauses";
import OtherClauses from "./tabSection/OtherClauses";
import TopHeader from "../layout/TopHeader";
import dateFormat, { masks } from "dateformat";
import { type } from "jquery";
import InvoiceValidationTab from "./tabSection/InvoiceValidationTab";
import LeaseInformation from "./tabSection/LeaseInformation";
import OtherRentalDetails from "./tabSection/OtherRentalDetails";
import LandlordCharges from "./tabSection/LandlordCharges";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseDetails extends React.Component {
  state = {
    redirect: false,
    leaseStatus: "",
    initialValues: {},
    leaseCreationDate: "",
    leaseId: "",

    unit: [],
    landlordDetails: [],
    landlordNotes: "",
    occupierNotes: "",
    leaseTermNotes: "",
    lockInNotes: "",
    rentalNotes: "",
    camNotes: "",
    utilitiesNotes: "",
    mfNotes: "",
    parkingNotes: "",
    pTaxNotes: "",
    rdNotes: "",
    cdNotes: "",
    odNotes: "",
    additionalDetails: {},
    subAssetName: "",
    subAssetNameValue: "",
    assetValue: "",
    towerValue: "",
    tower: "",
    occupierBrand: [],
    occupier: [],
    leaseTermDetails: [],
    renewalTerms: [],
    lockIn: [],
    lockInOccupier: [],
    rentalDetails: [],
    otherRental: [],
    camDetails: [],
    utilities: [],
    mfDetails: [],
    pTaxDetails: [],
    parkingStorageSignage: [],
    rentDepositDetails: [],
    camDepositDetails: [],
    otherDepositDetails: [],
    uploadedDocs: [],
    commercialClauses: [],
    otherClauses: [],
    brokerDetails: [],
    invoiceDetails: [],
    landlordChargeDetails: [],
    leaseData: {},
    universalKeyParties: 1212,
    universalKeyOccupier: 2020,
    universalKeyBroker: 123,
    universalKeyLease: 1010,
    universalKeyLockIn: 2533,
    universalKeyRental: 1322,
    universalKeyCam: 3699,
    universalKeyUtilities: 8789,
    universalKeyMf: 6145,
    universalKeyPtax: 5225,
    universalKeyPss: 3478,
    universalKeyRd: 1879,
    universalKeyCd: 37899,
    universalKeyOd: 4978,
    universalKeyFd: 8014,
    universalKeyCc: 7056,
    universalKeyOc: 2021,
    universalKeyInvoice: 8666,
    universalKeyLeaseData: 9907,
    id: this.props.leaseId,

    selectedOption: this.props.selectedOption,
    showPartiesUnit: true,
    showOccupier: false,
    showBrokerDetails: false,
    showLeaseTerm: false,
    showLockIn: false,
    showRental: false,
    showOtherRental: false,
    showCam: false,
    showUtilities: false,
    showMarketingFund: false,
    showProperty: false,
    showParking: false,
    showRentDeposit: false,
    showCamDeposit: false,
    showOtherDeposit: false,
    showUploadedDocs: false,
    showCommercial: false,
    showOther: false,
    showInvoice: false,
    showInfo: false,
    camDataApplicable: "",
    mfDataApplicable: "",
    parkingChargesApplicable: "",
    parkingCharges: {},
    camDepositApplicable: "",
    otherDepositApplicable: "",
    pTaxPayable: "",
    showLandlordCharges: false,
  };

  constructor(props) {
    super(props);
    //this.setState({ selectedOption: props.newSelection })
    //props.selectedOption("Rental Details");
    //this.handleClick = this.handleClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    //console.log(prevProps, "prev pros", this.props.selectedOption);
    if (this.props.selectedOption !== prevProps.selectedOption) {
      this.setState({ selectedOption: this.props.selectedOption }, () => {
        this.showLeaseData();
      });
    }
  }

  componentDidMount() {
    //this.props.selectedOption("Rental Details");//this.setState({ selectedOption: this.props.newSelection })

    fetch(
      `${apiUrl.apiUrl.url}/create-lease/get-lease-status?leaseId=` +
      this.state.id, { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseStatus: data.status,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getLeaseId(true);

    // fetch(
    //   `${apiUrl.apiUrl.url}/lease-view/fetch-lease-menus?leaseId=` +
    //     this.state.id
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState({
    //       leaseMenus: data.data,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  getLeaseId(setAllDetails) {

    let athis= this;
    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-landlord-form?id=${this.state.id}`).then((response)=>{
      let data = response.data;
      athis.state.universalKeyParties = Math.floor(Math.random() * 9) + 1;
      if (typeof setAllDetails == "undefined") {
        athis.setState({
          leaseId: data.leaseId,
        });
      } else {
        athis.setState({
          unit: data.units,
          leaseCreationDate: data.leaseCreationDate,
          leaseId: data.leaseId,
          costCenter: data.costCenter,
          subAssetName: data.subAssetName,
          tower: data.tower,
          landlordDetails: data.landlord,
          additionalDetails: data.additionalDetails,
          subAssetNameValue: data.subAssetNameValue,
          assetValue: data.assetName,
          towerValue: data.towerValue,
          landlordNotes: data.notes_1,
        });
      }
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-landlord-form?id=${this.state.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     console.log(data);
    //     this.state.universalKeyParties = Math.floor(Math.random() * 9) + 1;
    //     if (typeof setAllDetails == "undefined") {
    //       this.setState({
    //         leaseId: data.leaseId,
    //       });
    //     } else {
    //       this.setState({
    //         unit: data.units,
    //         leaseCreationDate: data.leaseCreationDate,
    //         leaseId: data.leaseId,
    //         costCenter: data.costCenter,
    //         subAssetName: data.subAssetName,
    //         tower: data.tower,
    //         landlordDetails: data.landlord,
    //         additionalDetails: data.additionalDetails,
    //         subAssetNameValue: data.subAssetNameValue,
    //         assetValue: data.assetName,
    //         towerValue: data.towerValue,
    //         landlordNotes: data.notes_1,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  showLeaseData(e) {
    var selectedVal = this.state.selectedOption;
    console.log(selectedVal);
    console.log(this.state.id);
    //   typeof dropdownval !== "undefined" ? dropdownval : e.target.value;

    if (selectedVal !== "Other Rental Details") {
      this.setState({ showOtherRental: false });
    }

    if (selectedVal == "Parties, Landlord & Unit Details") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-landlord-form?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data, "data1");
          this.state.universalKeyParties = Math.floor(Math.random() * 9) + 1;
          this.setState({
            leaseCreationDate: data.leaseCreationDate,
            leaseId: data.leaseId,

            unit: data.units,
            additionalDetails: data.additionalDetails,
            subAssetNameValue: data.subAssetNameValue,
            towerValue: data.towerValue,
            landlordNotes: data.notes_1,
            vendor_code: data.vendor_code,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: true,
        showOccupier: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showInvoice:false
      });
    } else if (selectedVal == "Occupier & Brand Details") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-occupier-form?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyOccupier = Math.floor(Math.random() * 9) + 1;
          this.setState({
            occupierBrand: data,
            occupier: data.occupier,
            additionalDetails: data.additionalDetails,
            occupierNotes: data.notes_2,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: true,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showInvoice: false
      });
    } else if (selectedVal == "Broker Details") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-broker-form?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyBroker = Math.floor(Math.random() * 9) + 1;
          this.setState({
            showPartiesUnit: false,
            showBrokerDetails: true,
            showOccupier: false,
            showLeaseTerm: false,
            showLockIn: false,
            showRental: false,
            showCam: false,
            showUtilities: false,
            showMarketingFund: false,
            showProperty: false,
            showParking: false,
            showRentDeposit: false,
            showCamDeposit: false,
            showOtherDeposit: false,
            showUploadedDocs: false,
            showCommercial: false,
            showOther: false,
            showInvoice: false,
            showInfo: false,
            brokerDetails: data,
            additionalDetails: data.additionalDetails,
            showLandlordCharges: false,
          });
          // this.setState({
          //   brokerDetails: data,
          //   additionalDetails: data.additionalDetails,
          // });
          this.setState({});
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (selectedVal == "Lease Term Details") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-term-form?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyLease = Math.floor(Math.random() * 9) + 1;
          this.setState({
            leaseTermDetails: data,
            renewalTerms: data.renewalTerms,
            leaseTermNotes: data.notes_3,
            additionalDetails: data.additionalDetails,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: true,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Lock In & Notice Period") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-lockin-form?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyLockIn = Math.floor(Math.random() * 9) + 1;
          this.setState({
            lockIn: data,
            lockInOccupier: data.lockInPeriodOccupier,
            additionalDetails: data.additionalDetails,
            lockInNotes: data.notes_4,
            // lockInApplicable:data.
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: true,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (
      selectedVal == "Rental Details" ||
      selectedVal == "Basic Rental Details"
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-rent-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyRental = Math.floor(Math.random() * 9) + 1;
          this.setState({
            rentalDetails: data.rentalDetails,
            additionalDetails: data.additionalDetails,
            rentalNotes: data.notes_5,
          });
          console.log(this.state.rentalDetails);
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: true,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Other Rental Details") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-other-rent-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyRental = Math.floor(Math.random() * 9) + 1;
          this.setState({
            otherRental: data.rentalDetails,
            additionalDetails: data.additionalDetails,
            rentalNotes: data.notes_16,
          });
          console.log(this.state.rentalDetails);
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showOtherRental: true,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "CAM Details") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-cam-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyCam = Math.floor(Math.random() * 9) + 1;
          this.setState({
            camDetails: data.camDetails,
            camDataApplicable: data.camApplicable,
            additionalDetails: data.additionalDetails,
            camNotes: data.notes_6,
          });
          console.log(this.state.camDetails);
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: true,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Utilities") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-utilities?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyUtilities = Math.floor(Math.random() * 9) + 1;
          this.setState({
            utilities: data.utilities,
            additionalDetails: data.additionalDetails,
            utilitiesNotes: data.notes_7,
          });
          console.log(this.state.utilities);
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: true,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Marketing Fund") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-marketing-fund-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyMf = Math.floor(Math.random() * 9) + 1;
          this.setState({
            mfDetails: data.marketingFundDetails,
            mfDataApplicable: data.marketingFundApplicable,
            mfNotes: data.notes_8,
            additionalDetails: data.additionalDetails,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: true,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Property & Municipal Tax") {
      console.log("hh");
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-property-tax-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyPtax = Math.floor(Math.random() * 9) + 1;
          this.setState({
            pTaxDetails: data.propertyTaxDetails,
            pTaxPayable: data.propertyTaxPayable,
            additionalDetails: data.additionalDetails,
            pTaxNotes: data.notes_9,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: true,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Parking Storage & Signage") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-pss-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyPss = Math.floor(Math.random() * 9) + 1;
          this.setState({
            parkingStorageSignage: data.parkingStorageSignage,
            parkingChargesApplicable: data.chargesApplicable,
            additionalDetails: data.additionalDetails,
            parkingNotes: data.notes_10,
            parkingCharges: data.parkingCharges,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: true,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Rent Deposit Details") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-rent-deposit-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyRd = Math.floor(Math.random() * 9) + 1;
          this.setState({
            rentDepositDetails: data.rentDepositDetails,
            additionalDetails: data.additionalDetails,
            rdNotes: data.notes_11,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: true,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "CAM Deposit Details") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-cam-deposit-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyCd = Math.floor(Math.random() * 9) + 1;
          this.setState({
            camDepositDetails: data.camDepositDetails,
            camDepositApplicable: data.camDepositApplicable,
            additionalDetails: data.additionalDetails,
            cdNotes: data.notes_12,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: true,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Other Deposit Details") {
      console.log(selectedVal);
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-other-deposit-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyOd = Math.floor(Math.random() * 9) + 1;
          this.setState({
            otherDepositDetails: data.otherDepositDetails,
            otherDepositApplicable: data.otherDepositApplicable,
            additionalDetails: data.additionalDetails,
            odNotes: data.notes_13,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: true,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Uploaded Documents") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-document?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyFd = Math.floor(Math.random() * 9) + 1;
          this.setState({
            uploadedDocs: data.data,
            additionalDetails: data.additionalDetails,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: true,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Critical Clauses - Commercial") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-commercial-clauses-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyCc = Math.floor(Math.random() * 9) + 1;
          this.setState({
            commercialClauses: data.commercialClausesDetails,
            leaseDocuments: data.lease_documents,
            additionalDetails: data.additionalDetails,
            cdNotes:data.notes_14
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: true,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Critical Clauses - Other") {
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-lease-other-clauses-details?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyOc = Math.floor(Math.random() * 9) + 1;
          this.setState({
            otherClauses: data.otherClausesDetails,
            leaseDocuments: data.lease_documents,
            additionalDetails: data.additionalDetails,
            cdNotes: data.notes_15	
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: true,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Invoice") {
      console.log("11");
      fetch(
        `${apiUrl.apiUrl.url}/sales-input/lease-invoice-detail-view?leaseId=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyInvoice = Math.floor(Math.random() * 9) + 1;
          this.setState({
            invoiceDetails: data,
            additionalDetails: data.additionalDetails,
          });
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: true,
        showInfo: false,
        showLandlordCharges: false
      });
    } else if (selectedVal == "Information") {
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/lease-details-view?leaseId=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.state.universalKeyLeaseData = Math.floor(Math.random() * 9) + 1;
          this.setState({
            leaseData: data.data,
          });
          this.state.additionalDetails = [];
          this.state.additionalDetails.title = "Information";
          this.setState({});
          //{this.state.additionalDetails.title
        })
        .catch((error) => {
          console.log(error);
        });
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: true,
        showLandlordCharges: false
      });
    }else if(selectedVal == 'Landlord Charge Type'){
      fetch(
        `${apiUrl.apiUrl.url}/create-lease/fetch-landlord-charges?id=${this.state.id}`, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          //console.log(data);
          this.setState({
            landlordChargeDetails: data.list,
            additionalDetails: data.additionalDetails,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
        showLandlordCharges: true
      });
      
      
    } else {
      this.setState({
        showPartiesUnit: false,
        showOccupier: false,
        showBrokerDetails: false,
        showLeaseTerm: false,
        showLockIn: false,
        showRental: false,
        showCam: false,
        showUtilities: false,
        showMarketingFund: false,
        showProperty: false,
        showParking: false,
        showRentDeposit: false,
        showCamDeposit: false,
        showOtherDeposit: false,
        showUploadedDocs: false,
        showCommercial: false,
        showOther: false,
        showInvoice: false,
        showInfo: false,
      });
    }

    if (this.props.leaseChecked != false) {
      this.props.leaseChecked(selectedVal);
    }
  }

  callToNextElement(e) {
    let nextindex = this.props.leaseMenus.indexOf(this.state.selectedOption);
    if (nextindex >= 0 && nextindex < this.props.leaseMenus.length - 1) {
      var nextItem = this.props.leaseMenus[nextindex + 1];
      this.setState(
        {
          selectedOption: nextItem,
        },
        () => {
          this.showLeaseData(e);
        }
      );

      console.log("new val", this.state.nextSelection);
      this.state.nextSelection = nextItem;
    }
  }

  callToPreviousElement(e) {
    let nextindex = this.props.leaseMenus.indexOf(this.state.selectedOption);
    if (nextindex > 0) {
      var nextItem = this.props.leaseMenus[nextindex - 1];
      this.setState(
        {
          selectedOption: nextItem,
        },
        () => {
          this.showLeaseData(e);
        }
      );

      console.log("new val", this.state.nextSelection);
      this.state.nextSelection = nextItem;
    }
    console.log(nextindex);
  }

  render() {
    return (
      <div>
        <div>
          <div>
            <div className="unitFormContainer leaseSubmitForm">
              {/* <Formik>
                {({
                  values,

                  errors,

                  touched,

                  handleChange,

                  handleBlur,

                  handleSubmit,

                  isSubmitting,
                }) => ( */}
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center"></div>
                  <div className="inputContainer ld col-lg-12">
                    <div className="row">
                      <div className="col">
                        <h5 style={{ fontWeight: "600", fontSize: "18px" }}>
                          Select Screen
                        </h5>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <span className="arrowContainer">
                            <FontAwesomeIcon
                              icon={faCaretLeft}
                              size="lg"
                              onClick={(e) => {
                                this.callToPreviousElement(e);
                              }}
                            />
                          </span>
                          <select
                            // className="noRadiusRight ms-2 me-2"
                            value={this.state.selectedOption}
                            onChange={(e) => {
                              this.setState(
                                {
                                  selectedOption: e.target.value,
                                },
                                () => {
                                  this.showLeaseData(e);
                                }
                              );
                              this.handleChange.bind(this);
                            }}
                          >
                            <option value="" label="Select" />

                            {this.props.leaseMenus.map((obj) => (
                              <option label={obj} value={obj} />
                            ))}
                          </select>
                          <span
                            className="arrowContainer me-4"
                            onClick={(e) => {
                              this.callToNextElement(e);
                            }}
                          >
                            <FontAwesomeIcon icon={faCaretRight} size="lg" />
                          </span>
                        </div>
                      </div>
                      {this.props.history.length > 0 && (
                        <div className="col">
                          <h5 style={{ fontWeight: "600", fontSize: "18px" }}>
                            View History
                          </h5>
                          <select
                            className="noRadiusRight"
                            value={this.state.id}
                            onChange={(e) => {
                              this.setState(
                                {
                                  id: e.target.value,
                                },
                                () => {
                                  this.showLeaseData(e);
                                  this.getLeaseId();
                                }
                              );
                              //this.handleChange.bind(this)
                            }}
                          >
                            <option value="" label="Select" />

                            {this.props.history.map((obj) => (
                              <option label={obj.code} value={obj.id} />
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* )}
               </Formik> */}
            </div>
            <div className="unitFormContainer submitLease mb-3">
              <div className="container-fluid p-0">
                <div className="row prospectAccordion">
                  <div className="col-lg-12">
                    <div className="tableContainer prospectTable mt-0">
                      <table className="table">
                        <tbody>
                          {/* <tr>
                            <th scope="col">Lease Creation Date</th>
                            <td>
                              {dateFormat(
                                this.state.leaseCreationDate,
                                "dd mmm yyyy"
                              )}
                            </td>
                          </tr> */}
                          <tr>
                            <th scope="col">Lease Id</th>
                            <td>{this.state.leaseId}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid" style={{ float: "left" }}>
              <div className="row">
                <div
                  className="col-lg-12"
                  style={{ backgroundColor: "#003971" }}
                >
                  <h3
                    style={{
                      fontSize: "18px",
                      textAlign: "center",
                      margin: "0",
                      paddingTop: "0.5rem",
                      paddingBottom: "0.5rem",
                      color: "#fff",
                    }}
                  >
                    {this.state.additionalDetails.title}
                    {` (`}
                    {this.state.additionalDetails.formType == ""
                      ? "Original"
                      : this.state.additionalDetails.formType}
                    {`)`}
                  </h3>
                </div>
              </div>
            </div>
            <div className="tabsContainer leaseSubmit container-fluid">
              <div className="row">
                {this.state.showPartiesUnit && (
                  <PartiesUnitDetails
                    unit={this.state.unit}
                    subAssetNameValue={this.state.subAssetNameValue}
                    towerValue={this.state.towerValue}
                    assetValue={this.state.assetValue}
                    landlordDetails={this.state.landlordDetails}
                    vendor_code={this.state.vendor_code}
                    landlordAdditionalDetails={
                      this.state.landlordAdditionalDetails
                    }
                    landlordNotes={this.state.landlordNotes}
                    key={this.state.universalKeyParties}
                  />
                )}
                {this.state.showOccupier && (
                  <OccupierBrandDetails
                    occupierBrand={this.state.occupierBrand}
                    occupier={this.state.occupier}
                    occupierNotes={this.state.occupierNotes}
                    vendor_code={this.state.vendor_code}
                    key={this.state.universalKeyOccupier}
                  />
                )}
                {this.state.showBrokerDetails && (
                  <BrokerDetails
                    brokerDetails={this.state.brokerDetails}
                    key={this.state.universalKeyBroker}
                  />
                )}
                {this.state.showLeaseTerm && (
                  <LeaseTermDetails
                    leaseTermDetails={this.state.leaseTermDetails}
                    renewalTerms={this.state.renewalTerms}
                    leaseTermNotes={this.state.leaseTermNotes}
                    key={this.state.universalKeyLease}
                  />
                )}
                {this.state.showLockIn && (
                  <LockInNoticePeriod
                    lockIn={this.state.lockIn}
                    lockInOccupier={this.state.lockInOccupier}
                    lockInNotes={this.state.lockInNotes}
                    key={this.state.universalKeyLockIn}
                  />
                )}
                {this.state.showRental && (
                  <RentalDetails
                    rentalDetails={this.state.rentalDetails}
                    rentalNotes={this.state.rentalNotes}
                    key={this.state.universalKeyRental}
                    basic={true}
                  />
                )}
                {this.state.showOtherRental && (
                  // <RentalDetails
                  //   rentalDetails={this.state.rentalDetails}
                  //   rentalNotes={this.state.rentalNotes}
                  //   key={this.state.universalKeyRental}
                  // />
                  <OtherRentalDetails
                    rentalDetails={this.state.otherRental}
                    rentalNotes={this.state.rentalNotes}
                    key={this.state.universalKeyRental}
                  />
                )}
                {this.state.showCam && (
                  <CamDetails
                    camDetails={this.state.camDetails}
                    camDataApplicable={this.state.camDataApplicable}
                    camNotes={this.state.camNotes}
                    key={this.state.universalKeyCam}
                  />
                )}
                {this.state.showUtilities && (
                  <Utilities
                    utilities={this.state.utilities}
                    utilitiesNotes={this.state.utilitiesNotes}
                    key={this.state.universalKeyUtilities}
                  />
                )}
                {this.state.showMarketingFund && (
                  <MarketingFund
                    mfDetails={this.state.mfDetails}
                    mfDataApplicable={this.state.mfDataApplicable}
                    mfNotes={this.state.mfNotes}
                    key={this.state.universalKeyMf}
                  />
                )}
                {this.state.showProperty && (
                  <PropertyTax
                    pTaxDetails={this.state.pTaxDetails}
                    pTaxPayable={this.state.pTaxPayable}
                    pTaxNotes={this.state.pTaxNotes}
                    key={this.state.universalKeyPtax}
                  />
                )}
                {this.state.showParking && (
                  <ParkingStorageSignage
                    parkingStorageSignage={this.state.parkingStorageSignage}
                    parkingNotes={this.state.parkingNotes}
                    chargesApplicable={this.state.parkingChargesApplicable}
                    parkingCharges={this.state.parkingCharges}
                    key={this.state.universalKeyPss}
                  />
                )}
                {this.state.showRentDeposit && (
                  <RentDeposit
                    rentDepositDetails={this.state.rentDepositDetails}
                    rdNotes={this.state.rdNotes}
                    key={this.state.universalKeyRd}
                  />
                )}
                {this.state.showCamDeposit && (
                  <CamDeposit
                    camDepositDetails={this.state.camDepositDetails}
                    camDepositApplicable={this.state.camDepositApplicable}
                    cdNotes={this.state.cdNotes}
                    key={this.state.universalKeyCd}
                  />
                )}
                {this.state.showOtherDeposit && (
                  <OtherDeposit
                    otherDepositDetails={this.state.otherDepositDetails}
                    otherDepositApplicable={this.state.otherDepositApplicable}
                    odNotes={this.state.odNotes}
                    key={this.state.universalKeyOd}
                  />
                )}
                {this.state.showUploadedDocs && (
                  <UploadDocuments
                    uploadedDocs={this.state.uploadedDocs}
                    key={this.state.universalKeyFd}
                  />
                )}
                {this.state.showCommercial && (
                  <CommercialClauses
                    commercialClauses={this.state.commercialClauses}
                    leaseDocuments={this.state.leaseDocuments}
                    cdNotes = {this.state.cdNotes}
                    key={this.state.universalKeyCc}
                  />
                )}
                {this.state.showOther && (
                  <OtherClauses
                    otherClauses={this.state.otherClauses}
                    leaseDocuments={this.state.leaseDocuments}
                    notes={this.state.cdNotes}
                    key={this.state.universalKeyOc}
                  />
                )}
                {this.state.showInvoice && (
                  <InvoiceValidationTab
                    invoiceDetails={this.state.invoiceDetails}
                    key={this.state.universalKeyInvoice}
                  />
                )}
                {this.state.showInfo && (
                  <LeaseInformation
                    leaseData={this.state.leaseData}
                    key={this.state.universalKeyLeaseData}
                  />
                )}
                {this.state.showLandlordCharges && (
                  <LandlordCharges
                    data={this.state.landlordChargeDetails}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LeaseDetails;
